import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'

import {
  defaultTopMargin,
  flexCenter,
  pageContentDefaultSize
} from 'style/emotion'

const NotificationsListContainer = styled('section')`
  ${pageContentDefaultSize}
  ${defaultTopMargin}
  ${flexCenter}

  flex-direction: column;
  height: auto;
  justify-content: flex-start;
`

const NotificationsListItem = styled('div')`
  --border: 1px solid var(--gray-2);

  ${flexCenter}

  align-items: flex-start;
  border: var(--border);
  border-bottom: none;
  cursor: pointer;
  padding: 16px;

  :last-of-type {
    border-bottom: var(--border);
  }

  :focus,
  :hover {
    background-color: var(--london-fog);
  }
`

const NotificationsListItemIcon = styled('div')`
  flex: 0 0 auto;
  margin-right: 16px;
  margin-top: -4px;

  > span {
    font-size: 1.5rem;
  }

  ${mediaQuery('tablet')} {
    margin-top: -2px;
  }
`

const NotificationsListItemDescription = styled('div')`
  flex: 1 1 auto;

  > span {
    display: block;
    font-weight: var(--not-read, 400);

    :nth-of-type(n + 2) {
      margin-top: 8px;
      font-size: 0.75rem;
    }
  }
`

const NotificationsListItemDate = styled('div')`
  flex: 0 0 25%;
  text-align: right;

  > span {
    font-size: 0.75rem;
    font-weight: var(--not-read, 400);
  }
`

export {
  NotificationsListContainer,
  NotificationsListItem,
  NotificationsListItemDate,
  NotificationsListItemDescription,
  NotificationsListItemIcon
}
